// Navigation section definitions — derived from role, translations, and badge counts.
import { useTranslation } from "react-i18next";
import {
  LayoutDashboard, ShoppingBag, UtensilsCrossed,
  Users, BarChart3, Settings, Megaphone, DollarSign,
  ShoppingCart, Calendar,
} from "lucide-react";

export function useSidebarMenu({ role, newOrderCount, newReservationCount }) {
  const { t } = useTranslation();
  return [
    {
      id: "dashboard",
      icon: LayoutDashboard,
      label: t('common.nav.dashboard'),
      path: "/dashboard",
    },
    {
      id: "reservas",
      icon: Calendar,
      label: t('common.nav.reservations'),
      badge: newReservationCount,
      children: [
        { label: t('common.nav.reservations'), path: "/reservations" },
        { label: "Regras de Capacidade", path: "/reservation-rules" },
      ],
    },
    {
      id: "operacoes",
      icon: ShoppingBag,
      label: t('common.nav.operations'),
      badge: newOrderCount,
      children: [
        { label: "POS", path: role === "sirviente" ? "/pos-terminal" : "/pos" },
        { label: t('common.nav.orders'), path: "/orders" },
        { label: t('common.nav.tables'), path: "/tables" },
        { label: t('common.nav.kitchen'), path: "/kitchen" },
        { label: "Kaysou Assist", path: "/kaysou-assist" },
        { label: t('common.nav.abandoned_orders'), path: "/abandoned-orders", ai: true },
      ],
    },
    {
      id: "menu",
      icon: UtensilsCrossed,
      label: t('common.nav.menu'),
      children: [
        { label: t('common.nav.catalog'), path: "/menu" },
        { label: t('common.nav.combos'), path: "/combos" },
        { label: t('common.nav.smart_menu'), path: "/smart-menu", ai: true },
        { label: t('common.nav.menu_engineering'), path: "/menu-engineering", ai: true },
      ],
    },
    {
      id: "clientes",
      icon: Users,
      label: t('common.nav.customers'),
      children: [
        { label: t('common.nav.customers'), path: "/customers" },
        { label: t('common.nav.leads'), path: "/leads" },
      ],
    },
    {
      id: "marketing",
      icon: Megaphone,
      label: t('common.nav.marketing'),
      children: [
        { label: t('common.nav.campaigns'), path: "/marketing" },
        { label: "Kaiso Revenue Intelligence", path: "/dashboard/behavioral-commerce", ai: true },
        { label: "Marketing IA", path: "/ai-marketing", ai: true },
        { label: "WiFi Marketing", path: "/wifi-marketing" },
        { label: "ChatBot", path: "/chatbot", newTab: true },
      ],
    },
    {
      id: "financeiro",
      icon: DollarSign,
      label: t('common.nav.financial'),
      children: [
        { label: t('common.nav.financial'), path: "/financiero" },
        { label: "KaisoPay", path: "/settings?tab=kaisopay" },
        { label: t('common.nav.time_clock'), path: "/ponto" },
        { label: t('common.nav.antifurto'), path: "/antifurto", ai: true },
      ],
    },
    {
      id: "relatorios",
      icon: BarChart3,
      label: t('common.nav.reports'),
      children: [
        { label: t('common.nav.reports'), path: "/reports" },
        { label: t('common.nav.kitchen_analytics'), path: "/kitchen-analytics" },
        { label: "IA Operacional", path: "/intelligence", ai: true },
        { label: "IA Ejecutiva", path: "/ai-insights", ai: true },
        { label: "Kaiso Brain", path: "/brain", ai: true },
        { label: t('common.nav.opportunities'), path: "/oportunidades", ai: true },
      ],
    },
    {
      id: "marketplace",
      icon: ShoppingCart,
      label: t('common.nav.marketplace'),
      path: "/marketplace",
    },
    {
      id: "config",
      icon: Settings,
      label: t('common.nav.settings'),
      children: [
        { label: t('common.nav.settings_sub'), path: "/settings" },
        { label: t('common.nav.printer'), path: "/printer-setup" },
        { label: t('common.nav.team'), path: "/team" },
        { label: t('common.nav.delivery_map'), path: "/map" },
        { label: t('common.nav.inventory'), path: "/stock" },
        { label: t('common.nav.integrations'), path: "/integrations" },
        { label: t('common.nav.franchise'), path: "/franchise" },
        { label: "Command Center", path: "/command-center", ownerOnly: true },
        { label: "IA Assistente", path: "/ai-assistant", ai: true },
        { label: t('common.nav.guide'), path: "/guia" },
      ],
    },
  ];
}
